import { BingIcon, BlueIcon, GoogleIcon, LinkedInIcon, TikTokIcon, MetaIcon } from 'assets/icons';

export const PAID_MEDIA_PLATFORMS = [
  { id: 'PMAX', name: 'PMAX', icon: GoogleIcon },
  { id: 'Blue', name: 'Blue', icon: BlueIcon },
  { id: 'Meta', name: 'Meta Ads', icon: MetaIcon },
  { id: 'Bing', name: 'Bing', icon: BingIcon },
  { id: 'Search', name: 'Search', icon: GoogleIcon },
  { id: 'LinkedIn', name: 'LinkedIn', icon: LinkedInIcon },
  { id: 'TikTok', name: 'TikTok', icon: TikTokIcon },
];
